import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../menu/header2';

// Import images
import screen1 from '../../../src/assets/churro122.png';
import screen2 from '../../../src/assets/churro2.png';
import screen3 from '../../../src/assets/churro3.png';

const Churro = () => {
  return (
    <>
      <Header />
      <Container
        fluid
        style={{
          backgroundColor: '#ffffff',
          padding: '20px',
          paddingTop: '100px' // Adjust this value to match your header's height
        }}
      >
        <Row>
          {/* Left column: Images */}
          <Col md={7}>
            <img src={screen1} alt="ChurroSwap Screen 1" className="img-fluid mb-3" />
            <img src={screen2} alt="ChurroSwap Screen 2" className="img-fluid mb-3" />
            <img src={screen3} alt="ChurroSwap Screen 3" className="img-fluid" />
          </Col>

          {/* Right column: Content */}
          <Col md={5} className="text-dark">
            <h1>ChurroSwap</h1>
            <h3>Gamified Learning Platform</h3>
            <h3>
              <a href= "https://churro.vercel.app/" >churroswap.io</a>
            </h3>
            <p>
              ChurroSwap is a gamified e-learning platform built for English and Spanish speakers.
              It features an introductory NFT collection, a game, a DEX, and e-learning elements.
            </p>
            <h3>Key Features</h3>
            <ul>
              <li>Utility-based NFT collection</li>
              <li>Decentralized Automated Market Maker</li>
              <li>Token generating video game</li>
              <li>E-learning course</li>
            </ul>
            <h3>Challenges</h3>
            <p>
              We were faced with the task of making a variety of very customized and advanced features that are quite innovative.
              The first was a decentralized exchange. The exchange is a customized version of SushiSwap and can be used to trade any ERC20 token and create any liquidity pool.
              It features Chainlink oracle integration for very precise price information that gets sent directly to our smart contracts.
              We had to ensure everything worked as intended within the BNB Chain.
            </p>
            <p>
              Another challenge was generating a token from our play-to-earn game.
              Not only did we build a scalable video game, but we also ensured a seamless connection between Unity, the React website, and our smart contracts.
              The game is token-gated to verify that users hold the requisite NFT to claim rewards.
            </p>
            <p>
              Perhaps our biggest challenge was securing the minting of the ERC20 token from the game.
              Anyone could mint tokens, so we had to ensure that only the game could perform this action by using a centralized server that cryptographically verifies the mint request.
            </p>

            <Row className="mt-3">
              <Col xs={6}>
                <h3>MVP Completion Date</h3>
                <p>October 2024</p>
              </Col>
              <Col xs={6}>
                {/* Optionally add client or other info here */}
              </Col>
            </Row>

            <Row className="mt-3">
              <Col xs={6}>
                <h3>Skills Used</h3>
                <p>
                  Smart Contract development, Game Development, Website development, Branding, Brand Strategy,
                  Tokenomics, Finance, Cryptography, Content design
                </p>
              </Col>
              <Col xs={6}>
                <h3>Technology Used</h3>
                <p>
                  Solidity for Smart Contracts, React, Unity Engine, MetaMask, Chainlink Oracles,
                  web2 server APIs, Adobe Creative Cloud
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Churro;
